import { useUsers } from '../context/usersContext';
import { normalizeUnitId } from '../utils/unitScope';

const normalizePermissionText = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/\s+/g, ' ')
  .trim()
  .toUpperCase();

const VisibleAccess = ({ compareField, compareValues, children, fallback = null }) => {
  const { userInfo, effectiveUnitId } = useUsers();

  const hasPermission = () => {
    const compareList = Array.isArray(compareValues) ? compareValues : [compareValues];

    if (compareField === 'groups') {
      const fieldValue = userInfo?.groups;
      if (!fieldValue) return false;

      const normalizedTarget = compareList.map(normalizePermissionText);
      const normalizedCurrent = Array.isArray(fieldValue)
        ? fieldValue.map(normalizePermissionText)
        : [normalizePermissionText(fieldValue)];

      return normalizedCurrent.some((group) => normalizedTarget.includes(group));
    }

    if (compareField === 'unit') {
      const currentUnit = normalizeUnitId(effectiveUnitId);
      if (currentUnit === null) return false;

      const normalizedTargetUnits = compareList
        .map((value) => normalizeUnitId(value))
        .filter((value) => value !== null);

      return normalizedTargetUnits.some((value) => String(value) === String(currentUnit));
    }

    const fieldValue = userInfo?.[compareField];
    if (fieldValue === null || fieldValue === undefined) return false;

    // Se for array, usa some() para verificar se algum valor está incluído
    if (Array.isArray(fieldValue)) {
      return compareList.some((value) => fieldValue.includes(value));
    }

    // Se for string ou número, compara diretamente
    return compareList.includes(fieldValue);
  };

  return hasPermission() ? children : fallback;
};

export default VisibleAccess;

// Modelo de uso, no caso comparando o campo unit do usuario logado com a unidade acessada

// <VisibleAccess compareField="unit" compareValues={internalDetails ? internalDetails.unit : null}> */}
//  <button className='btnAdcionar btn-image' onClick={handleImageModal}>+</button> */}
// </VisibleAccess>

// Modelo de uso para mudar o incone
// <VisibleAccess
//  compareField="unit"
//  compareValues={internalDetails ? internalDetails.unit : null}
//  fallback={<FontAwesomeIcon icon={faEye} />}
// >
//  <FontAwesomeIcon icon={faPencilAlt} />
//</VisibleAccess >
